module.exports = __webpack_public_path__ + "36153e11fef437051d3c6532fd761087.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/152.png
// module id = 1747
// module chunks = 2